import React, { useState, useEffect } from "react"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"
import ProductImageSlider from "../../../src/components/molecules/ProductImageSlider"
import DealerFinder from "../modules/DealerFinder"
import NexmartPanel from "../modules/NexmartPanel"
import Image from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Image"
import Button from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Button"
import useRukoGeodata from "../../hooks/useRukoGeodata"

import { Menu } from "@headlessui/react"
import { ChevronDown16, CloseOutline20, Location32 } from "@carbon/icons-react"
import { Dialog, Transition } from "@headlessui/react"

import { useTranslation } from "react-i18next"
import NewFlag from "../atoms/NewFlag"
import useDateCheck from "../../hooks/useDateCheck"
import Headline from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Headline"
import ProductData from "./ProductData"
import useNexmartRetailers from "../../hooks/useNexmartRetailers"
import ProductDataGrid from "./ProductDataGrid"
import VariantChangeOver from "../atoms/VariantChangeOver"

import ShowMoreFoldable from "../molecules/ShowMoreFoldable"

const MultiVariantProductOverview = ({
  product,
  primaryVariant,
  variants,
  language,
}) => {
  const { isNewToggle, isNewFromDate, isNewUntilDate } = product
  const shouldDisplayNewFlag = useDateCheck(
    isNewToggle.value,
    isNewFromDate?.value,
    isNewUntilDate?.value
  )
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [activeVariantKey, setActiveVariantKey] = useState(null)
  const [activeVariant, setActiveVariant] = useState(null)
  const [showNexmart, setShowNexmart] = useState(false)
  const [nexmartSku, setNexmartSku] = useState(null)
  const { t } = useTranslation()
  const { allowNexmart, locationData } = useRukoGeodata()
  const [hasRetailers, retailers, isLoading] = useNexmartRetailers(nexmartSku)

  const handleVariantChange = (sku) => {
    setActiveVariantKey(sku)
    setActiveVariant(variants.find((v) => v.node.externalKey === sku).node)
  }

  const locationToVariant = () => {
    if (window !== undefined && window.location.hash) {
      window.scrollTo(0, 0)
      handleVariantChange(window.location.hash.split("#")[1])
    }
  }

  useEffect(() => {
    locationToVariant()
    if (window !== undefined) {
      window.addEventListener("hashchange", () => {
        locationToVariant()
      })
    }

    return () => {
      window.removeEventListener("hashchange", () => {
        locationToVariant()
      })
    }
  }, [variants])

  useEffect(() => {
    if (allowNexmart) {
      setNexmartSku(activeVariantKey)
    }
    // TODO: delete me
    setNexmartSku(activeVariantKey)
  }, [allowNexmart, activeVariantKey])

  return (
    <section data-product-obj-id={activeVariant?.ID}>
      <div className="block-w-container">
        <div className="flex flex-row flex-wrap -mx-grid">
          <div className="w-full md:w-1/2 px-grid">
            <div className="relative w-full overflow-hidden">
              {shouldDisplayNewFlag && <NewFlag />}
              <ProductImageSlider variant={primaryVariant} />
            </div>
          </div>
          <div className="w-full md:w-1/2 px-grid">
            <div data-product-attr-id={product?.displayName?.originId}>
              <Headline
                headline={product?.displayName?.value}
                headlineLevel="h2"
                tagName="h1"
              />
            </div>
            <div
              className="pt-4 -mt-4"
              data-product-attr-id={
                primaryVariant?.changeOverLabel?.resolvedOriginId
              }
            >
              {variants.length > 1 && (
                <div className="relative w-full mt-4 mr-4">
                  <Menu as="div" name="variant-select">
                    {activeVariant !== null ? (
                      <Menu.Button className="relative w-full px-3 py-2 text-left border border-gray-300">
                        <VariantChangeOver
                          label={activeVariant.changeOverLabel.label}
                          value={activeVariant.changeOverLabel.value}
                          active={true}
                          containerType={
                            activeVariant.variantContainerType.value
                          }
                        />
                        <ChevronDown16 className="absolute align-middle right-3 top-3" />
                      </Menu.Button>
                    ) : (
                      <Menu.Button className="relative w-full px-3 py-2 text-left border border-gray-300">
                        Variante wählen
                        <ChevronDown16 className="absolute align-middle right-3 top-3" />
                      </Menu.Button>
                    )}
                    <Menu.Items className="absolute max-h-[50vh] overflow-y-scroll overflow-x-hidden z-50 -mt-px top-full flex flex-col border w-auto border-gray-300 bg-white min-w-[100%]">
                      {variants.map((variant, index) => (
                        <Menu.Item className="block w-full" key={index}>
                          <div>
                            <button
                              className={`block px-grid py-1 hover:text-primary hover:bg-gray-100 w-full text-left`}
                              onClick={(e) => {
                                handleVariantChange(variant.node.externalKey)
                                window.history.pushState(
                                  { selectedVariant: variant.node.externalKey },
                                  "",
                                  "#" + variant.node.externalKey
                                )
                              }}
                            >
                              <VariantChangeOver
                                label={primaryVariant.changeOverLabel.label}
                                value={variant?.node.changeOverLabel?.value}
                                active={
                                  variant.node.changeOverLabel.value ===
                                  activeVariant?.changeOverLabel?.value
                                }
                                containerType={
                                  variant?.node?.variantContainerType?.value
                                }
                              />
                            </button>
                          </div>
                        </Menu.Item>
                      ))}
                    </Menu.Items>
                  </Menu>
                </div>
              )}
            </div>
            {/*  nexmart direct retailers display  */}
            {hasRetailers && !isLoading ? (
              <div className="mt-4">
                <label className="block py-2 text-sm" htmlFor="retailers">
                  {t("generic.tabs.available_at_online_retailers", {
                    count: retailers.length,
                  })}
                </label>
                <output
                  name="retailers"
                  className="grid grid-cols-2 gap-3 xl:grid-cols-3"
                >
                  {retailers.map((retailer) => (
                    <div className="w-full" key={retailer.rank}>
                      <a
                        href={retailer.products[0].onlineDeeplink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-center h-20 p-8 overflow-y-hidden border border-gray-300 hover:border-primary"
                      >
                        <Image
                          className="object-contain w-full h-44"
                          image={retailer.logoUrl}
                        />
                      </a>
                    </div>
                  ))}
                  <div className="w-full">
                    <button
                      onClick={() => setIsModalOpen(true)}
                      className="flex items-center justify-between w-full h-20 bg-gray-100 border border-gray-300 hover:border-primary group"
                    >
                      <Location32 className="w-12 pl-2 text-primary" />
                      <div className="w-3/4 pl-1 pr-6 text-sm font-bold text-left group-hover:text-primary">
                        {t("generic.tabs.buy_at_local_dealer")}
                      </div>
                    </button>
                  </div>
                </output>
              </div>
            ) : (
              <div className="w-full">
                <div className="block py-2 text-sm">
                  {/* {t("generic.tabs.available_at_online_retailers", {
                    count: 0,
                  })} */}
                </div>
                <div className="w-1/2 pr-3 h-fit xl:w-1/3">
                  <button
                    onClick={() => setIsModalOpen(true)}
                    className="flex items-center justify-between w-full h-20 bg-gray-100 border border-gray-300 hover:border-primary group"
                  >
                    <Location32 className="w-12 pl-2 text-primary" />
                    <div className="w-3/4 pl-1 pr-6 text-sm font-bold text-left group-hover:text-primary">
                      {t("generic.tabs.buy_at_local_dealer")}
                    </div>
                  </button>
                </div>
              </div>
            )}
            {/* TODO WHATSAPP */}
            {/* <a
              className="inline-block py-2 mt-4 mr-4 border border-gray-100 md:hidden px-grid hover:text-primary"
              href={`whatsapp://send?text=${product.displayName} – ${entry.changeOverLabel?.value}: ${process.env.GATSBY_ORIGINAL_HOST}${entry.fullSlug}`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                width="16"
                height="16"
                viewBox="0 0 32 32"
                aria-hidden="true"
                className="inline-block -mt-0.5 align-middle"
              >
                <path
                  d="M27.2071429,4.65 C24.2142857,1.65 20.2285714,0 15.9928571,0 C7.25,0 0.135714286,7.11428571 0.135714286,15.8571429 C0.135714286,18.65 0.864285714,21.3785714 2.25,23.7857143 L0,32 L8.40714286,29.7928571 C10.7214286,31.0571429 13.3285714,31.7214286 15.9857143,31.7214286 L15.9928571,31.7214286 C24.7285714,31.7214286 32,24.6071429 32,15.8642857 C32,11.6285714 30.2,7.65 27.2071429,4.65 Z M15.9928571,29.05 C13.6214286,29.05 11.3,28.4142857 9.27857143,27.2142857 L8.8,26.9285714 L3.81428571,28.2357143 L5.14285714,23.3714286 L4.82857143,22.8714286 C3.50714286,20.7714286 2.81428571,18.35 2.81428571,15.8571429 C2.81428571,8.59285714 8.72857143,2.67857143 16,2.67857143 C19.5214286,2.67857143 22.8285714,4.05 25.3142857,6.54285714 C27.8,9.03571429 29.3285714,12.3428571 29.3214535,15.8642857 C29.3214535,23.1357143 23.2571429,29.05 15.9928571,29.05 Z M23.2214286,19.1785714 C22.8285714,18.9785714 20.8785714,18.0214286 20.5142857,17.8928571 C20.15,17.7571429 19.8857143,17.6928571 19.6214286,18.0928571 C19.3571429,18.4928571 18.6,19.3785714 18.3642857,19.65 C18.1357143,19.9142857 17.9,19.95 17.5071429,19.75 C15.1785714,18.5857143 13.65,17.6714286 12.1142857,15.0357143 C11.7071429,14.3357143 12.5214286,14.3857143 13.2785714,12.8714286 C13.4071429,12.6071429 13.3428571,12.3785714 13.2428571,12.1785714 C13.1428571,11.9785714 12.35,10.0285714 12.0214286,9.23571429 C11.7,8.46428571 11.3714286,8.57142857 11.1285714,8.55714286 C10.9,8.54285714 10.6357143,8.54285714 10.3714286,8.54285714 C10.1071429,8.54285714 9.67857143,8.64285714 9.31428571,9.03571429 C8.95,9.43571429 7.92857143,10.3928571 7.92857143,12.3428571 C7.92857143,14.2928571 9.35,16.1785714 9.54285714,16.4428571 C9.74285714,16.7071429 12.3357143,20.7071429 16.3142857,22.4285714 C18.8285714,23.5142857 19.8142857,23.6071429 21.0714286,23.4214286 C21.8357143,23.3071429 23.4142857,22.4642857 23.7428571,21.5357143 C24.0714286,20.6071429 24.0714286,19.8142857 23.9714286,19.65 C23.8785714,19.4714286 23.6142857,19.3714286 23.2214286,19.1785714 Z"
                  id="Shape"
                ></path>
              </svg>
            </a> */}
            {/* {entry?.pictogramImages?.items?.length > 0 && (
              <div
                className="flex flex-row flex-wrap -mt-4"
                data-product-attr-id={entry?.pictogramImages?.originId}
              >
                {entry?.pictogramImages?.items?.map((item, index) => (
                  <CloudinaryImage
                    key={index}
                    fillColor="ffffff"
                    aspectRatio="1by1"
                    className="w-10 h-auto mt-2 mr-2"
                    image={item.value}
                    forceLoad={true}
                  />
                ))}
              </div>
            )} */}
            <ShowMoreFoldable>
              {primaryVariant?.deliveryScope?.value && (
                <div
                  className="mt-4 max-w-none"
                  data-product-attr-id={primaryVariant?.deliveryScope?.originId}
                >
                  <p>{primaryVariant?.deliveryScope?.value}</p>
                </div>
              )}
              {primaryVariant?.longDescriptionHtml?.value && (
                <div
                  data-product-attr-id={
                    primaryVariant?.longDescriptionHtml?.originId
                  }
                  className="mt-4 prose max-w-none"
                  dangerouslySetInnerHTML={{
                    __html: primaryVariant?.longDescriptionHtml?.value,
                  }}
                ></div>
              )}
              {primaryVariant?.productBenefitsHtml?.value && (
                <>
                  <Headline
                    headline={primaryVariant?.productBenefitsHtml?.label}
                    headlineLevel="h4"
                    tagName="h4"
                    className="pt-5"
                  />

                  <div
                    data-product-attr-id={
                      primaryVariant?.productBenefitsHtml?.originId
                    }
                    className="mt-4 prose max-w-none"
                    dangerouslySetInnerHTML={{
                      __html: primaryVariant?.productBenefitsHtml?.value,
                    }}
                  ></div>
                </>
              )}
            </ShowMoreFoldable>
            {variants.map((v) => (
              <div
                className="pt-8"
                key={`head-data-${v.node.externalKey}`}
                data-pim-var-id={v.node.externalKey}
                hidden={v.node.externalKey !== activeVariantKey}
              >
                <ProductData
                  keyValueItems={
                    [
                      v.node.articleNumber,
                      v.node.sapArticleNumber,
                      ...v.node.dimensionalData,
                    ].filter((e) => !!e) // remove nulls
                  }
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {variants.map((v) => (
        <div
          key={`variant-data-grid-${v.node.externalKey}`}
          hidden={v.node.externalKey !== activeVariantKey}
        >
          <ProductDataGrid entry={v.node} />
        </div>
      ))}

      <Transition appear show={isModalOpen} as={React.Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-10 overflow-y-auto "
          onClose={() => setIsModalOpen(false)}
        >
          <Dialog.Overlay className="fixed inset-0 flex bg-black bg-opacity-50">
            <div className="self-center w-full block-w-container">
              <div className="h-[calc(100vh_-_4rem)] bg-white relative m-4">
                <button
                  className="absolute z-20 right-4 top-4"
                  onClick={() => setIsModalOpen(false)}
                >
                  <CloseOutline20 />
                </button>
                <section className="h-full overflow-y-auto">
                  <div className="flex flex-col w-full h-full mx-auto">
                    {locationData !== undefined && (
                      <DealerFinder
                        userLocationCountry={
                          locationData &&
                          locationData.country &&
                          locationData.country.name
                            ? locationData.country.name
                            : null
                        }
                        containerWidth="100%"
                        containerHeight="100%"
                      />
                    )}
                  </div>
                </section>
              </div>
            </div>
          </Dialog.Overlay>
        </Dialog>
      </Transition>
    </section>
  )
}

export default MultiVariantProductOverview
